// eslint-disable-next-line
import React, { useState } from 'react'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { getTime } from '../../utils/convert-time'
import { AccordianComp } from '../helpers/ChakraAccordian'
import { Dropdown } from '../helpers/Dropdown'
import { RiHeartLine, RiPauseLine, RiPlayLine } from 'react-icons/ri'

export const TracksList = () => {
  let headerText = "PLAYING NEXT"
  const { trackList, currentTrackName, playTrack, isPlaying } = useMusicPlayer()
  const [toggle, setToggle] = useState( false )
  const [hearted, setHearted] = useState( false )
  const onToggle = () => setToggle( !toggle )

  return (
    <article className="queue__wrapper">
      <AccordianComp
        header={headerText} onToggle={onToggle}
      />
      <table className="queue__list" id="tracksList">
        {toggle ? trackList && trackList.map( ( track, index ) => {
          let artist = track?.ar ? track?.ar?.name : track.artists?.name
          return (
            <tbody key={track.id ? track.id : index}
              id="tracksBody">
              <tr className="queue__item">
                <td>{index + 1}</td>
                <td className="queue__item title">
                  <p>{track.name}</p>
                  <span>{artist}</span>
                </td>
                <td className="queue__item play">
                  <button
                    type="button"
                    className="queue__item btn"
                    onClick={() => playTrack( index )}
                  >
                    {currentTrackName === track.name && isPlaying
                      ? <RiPauseLine
                        style={{
                          color: "#fff"
                        }}
                        className="paus__btn"
                      />
                      : <RiPlayLine
                        style={{
                          color: "#fff",
                          width: "1em",
                          height: "1em"
                        }}
                        className="play__btn"
                      />
                    }
                  </button>
                </td>
                <td className="queue__item length">
                  <span>
                    {track.dt || track?.duration ? getTime( track?.dt ? track.dt : track?.duration ) : track.length}
                  </span>
                </td>
                <td className="queue__item svg">
                  <RiHeartLine
                    fill="#fff"
                    h="0.8em"
                    w="0.8em"
                  // onClick={() => setHearted( !hearted )}
                  />
                </td>
                <td className="queue__item svg btn">
                  <Dropdown track={track}
                  />
                </td>
              </tr>
            </tbody>
          )
        } ) : null
        }
      </table>
    </article>
  )
}